
import React from "react";
import { useDividendsColumns } from "./useDividendsColumns";
import { DividendList } from "../../../data/reports/dividends/types";
import { PaginationTable, PaginationDataProps,} from "../../components/common/PagginationTable";
import { useDividendsActions } from "./useDividendsActions";
import { AccessRights } from "../../../core/navigation/types";

export interface DividendsTableProps {
  userAccessRights: AccessRights;
  getData: () => void;
}


type DividendTablePropsType = DividendsTableProps &
  PaginationDataProps<DividendList>;

const DividendsTable: React.FunctionComponent<DividendTablePropsType> = ({
  userAccessRights,
  getData,
  ...tableProps
}) => {
  const actions = useDividendsActions();
  const columns = useDividendsColumns();

  return (
    <PaginationTable<DividendList>
      {...tableProps}
      getData={getData}
      title=""
      columns={columns}
      actions={actions}
      options={{
        actionsColumnIndex: -1,
        search: false,
        toolbar: false,
      }}
//      editable={{
//        onRowDelete: onDeleteNews,
//      }}

    />
  );
};

export default DividendsTable;
